// extracted by mini-css-extract-plugin
module.exports = {"flex":"style__flex__7zvQJ","siteLabel":"style__siteLabel__ZtIB0","modalFooter":"style__modalFooter__mS4JG","buttonBox":"style__buttonBox__ClDiV","button":"style__button__g7oYj"};